import get from 'lodash/get';
import * as tagScrollingModuleActions from '../../action_creators/tag/tag_scrolling_module_action_creators';
import TagScrollingModuleModel from '../../../models/tag/tag_scrolling_module';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchTag(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagScrollingModuleActions.tagScrollingModuleLoading({}, store));
    return TagScrollingModuleModel.fetch(params, store)
      .then(function handleTagDetailData(TagData) {
        dispatch(
          tagScrollingModuleActions.tagScrollingModuleLoaded(
            TagData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in tag scrolling module actions, message: ${err.message}`
          );
        }
        dispatch(
          tagScrollingModuleActions.tagScrollingModuleLoadError(err, store)
        );
      });
  };
}
